import React from "react";
import {
  FaHtml5,
  FaCss3Alt,
  FaJsSquare,
  FaReact,
  FaNodeJs,
  FaFigma,
  FaDocker,
  FaGit,
} from "react-icons/fa";
import {
  SiMongodb,
  SiMysql,
  SiExpress,
  SiRedux,
  SiTailwindcss,
  SiFirebase,
  SiNextdotjs,
  SiJsonwebtokens,
  SiTypescript,
  SiMui,
  SiBootstrap,
  SiPyup,
  SiPostman
} from "react-icons/si";
import { TbBrandCpp, TbBrandLaravel, TbBrandPhp } from "react-icons/tb";

const Skills = () => {
  return (
    <section className="pt-20">
      <div className="grid grid-cols-1 text-center md:grid-cols-4 xl:grid-cols-8 gap-6 xl:gap-10">
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <FaReact className="text-7xl inline" />
            <p className="block">React</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiRedux className="text-7xl inline" />
            <p className="block">Redux.js</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div>
            <FaNodeJs className="text-7xl" />
            <p className="block">Node Js</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div>
            <SiExpress className="text-7xl inline" />
            <p className="block">Express Js</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiMysql className="text-7xl inline" />
            <p className="block">MySQL</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiMongodb className="text-7xl inline" />
            <p className="block">Mongo DB</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <FaJsSquare className="text-7xl inline" />
            <p className="block">JavaScript</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiTypescript className="text-7xl inline" />
            <p className="block">TypeScript</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <TbBrandLaravel className="text-7xl inline" />
            <p className="block">Laravel</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div>
            <SiFirebase className="text-7xl inline" />
            <p className="block">Firebase</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiJsonwebtokens className="text-7xl inline" />
            <p className="block">JWT</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div>
            <FaHtml5 className="text-7xl inline" />
            <p className="block">HTML5</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div>
            <FaCss3Alt className="text-7xl" />
            <p className="block">Css3</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiTailwindcss className="text-7xl inline" />
            <p className="block">Tailwindcss</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiMui className="text-7xl inline" />
            <p className="block">Material UI</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiBootstrap className="text-7xl inline" />
            <p className="block">Bootstrap</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiPyup className="text-7xl inline" />
            <p className="block">Yup</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div>
            <FaFigma className="text-7xl" />
            <p className="block">Figma</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiNextdotjs className="text-7xl inline" />
            <p className="block">Next.js</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <FaDocker className="text-7xl inline" />
            <p className="block">Docker</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <SiPostman className="text-7xl inline" />
            <p className="block">Postman</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <FaGit className="text-7xl inline" />
            <p className="block">Git</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <TbBrandCpp className="text-7xl inline" />
            <p className="block">Cpp</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-32 h-32" data-aos="zoom-in-up">
          <div className="text-center">
            <TbBrandPhp className="text-7xl inline" />
            <p className="block">PHP</p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Skills;
